// removed by extract-text-webpack-plugin
module.exports = {"appContainer":"_2Hk3_appContainer"};


//////////////////
// WEBPACK FOOTER
// ./src/components/App/App.module.scss
// module id = 451
// module chunks = 42